// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"75385700","732":"aa4124c4","977":"0ba9d565"}[chunkId] + ".chunk.js";
};